<template>
  <vue-scroll>
    <rabbey-toolbox :call-new="callNew" />

    <RabbeyTable3
      :columns="columns"
      :data="items"
      style="margin: 20px"
      :actions="actions"
      @rtable-push-action="handlePushAction"
    />

    <el-drawer
      :title="tituloDrawer"
      :visible="openDetail"
      :size="sizedrawer"
      :before-close="CloseTransactionDetail"
    >
      <el-row :gutter="20" v-if="mostrardetalles">
        <el-col :offset="1">
          <h3>{{ textoTipo }}</h3>
          <span>{{ textoDescripcion }}</span>
        </el-col>
        <hr />
      </el-row>
      <el-form
        :model="VersionControl"
        :rules="rules"
        ref="VersionControl"
        label-width="120px"
        class="demo-ruleForm"
        :label-position="posionlabel"
        style="margin-left: 20px"
      >
        <el-row :gutter="20">
          <el-col :span="16"
            ><el-form-item label="Nombre" prop="nombre">
              <el-input v-model="VersionControl.nombre"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Version" prop="version">
              <el-input v-model="VersionControl.version"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Cliente" prop="clientCode">
              <el-select
                placeholder="Cliente"
                v-model="VersionControl.clientCode"
                filterable
                clearable
              >
                <el-option
                  v-for="(item, index) in list_customersSelect"
                  :key="index"
                  :value="item.ClientCode"
                  :label="item.Name"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="Url Google" prop="urlGoogle">
              <el-input v-model="VersionControl.urlGoogle"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Url Apple" prop="urlApple">
              <el-input v-model="VersionControl.urlApple"></el-input>
            </el-form-item>
          </el-col>
          <el-col :offset="10"> </el-col>
          <el-col :span="20">
            <el-form-item label="Descripcion" prop="descripcion">
              <el-input
                type="textarea"
                :rows="5"
                v-model="VersionControl.descripcion"
                width="3000px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="Archivo Zip Link" prop="archivoZipLink">
              <el-input
                disabled
                v-model="VersionControl.archivoZipLink"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item
              label="Adjuntar documento"
              style="font-weight: bold"
              :rules="[{ required: true, message: 'El nombre es requerido' }]"
            >
              <el-upload
                ref="uploadFile"
                class="upload-demo"
                :drag="true"
                action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
                :file-list="fileList"
                :auto-upload="true"
                :multiple="true"
                :on-success="handleUploadOnSuccess"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  Suelta tu archivo aquí o <em>haz clic para cargar</em>
                </div>
                <div slot="tip" class="el-upload__tip">
                  Solo archivos con un tamaño menor de 4MB
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :offset="17">
            <el-button
              type="primary"
              @click="manageVersion()"
              v-if="versioncontrolboton"
              >{{ this.BotonManage }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-drawer>
  </vue-scroll>
</template>

<script>
// import { formatDate } from "../../utils";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import { mapGetters, mapActions } from "vuex";

// import RenderCheckLabel from "@/components/functionals/RenderCheckLabel.vue";

export default {
  name: "VersionControl",
  components: {
    RabbeyTable3
    // RenderCheckLabel
    // RenderCheckLabelRequired
  },
  data() {
    return {
      VersionControl: {
        id: 0,
        types: "",
        version: "",
        nombre: "",
        clientCode: "",
        descripcion: "",
        urlGoogle: "",
        urlApple: "",
        archivoZipLink: ""
      },
      rules: {
        nombre: [
          {
            required: true,
            message: "Por favor Ingrese un tipo",
            trigger: "blur"
          }
        ],
        version: [
          {
            required: true,
            message: "Por favor Ingrese un tipo",
            trigger: "blur"
          }
        ],
        archivoZipLink: [
          {
            required: true,
            message: "Por favor Ingrese un tipo",
            trigger: "blur"
          }
        ]
      },
      items: [],
      mostrarselect: false,
      title: "Crear version app",
      drawer: false,
      isView: false,
      startedtime: false,
      isEdit: false,
      value1: true,
      mostrardetalles: true,
      // mostrartable: false,
      sizedrawer: "30%",
      id: 0,
      nombre: "",
      version: "",
      descripcion: "",
      urlGoogle: "",
      urlApple: "",
      archivoZipLink: "",
      fileList: [],
      textoTipo: "",
      textoDescripcion: "",
      posionlabel: "",
      frecuencia: false,
      viewselect: false,
      versioncontrolboton: false,
      mostarRequerido: true,
      mostrarEstatus: true,
      mostrartable: true,
      mostrarbotonquestion: false,
      checked: true,
      typebuttom: "el-icon-check",
      tituloDrawer: "Gestion de Preguntas ",
      openDetail: false,
      typerequest: 1,
      questionId: 0,
      No_Form: 0,
      mostrardescipccion: false,
      labelPosition: "right",
      mostrarselecttipo: true,
      imputpreguntas: "",
      itemsquestions: [],
      DescripccionEncuesta: "",
      columns: [
        {
          prop: "id",
          label: "id",
          fixed: true,
          minWidth: 50
        },
        {
          prop: "nombre",
          label: "Nombre",
          minWidth: 100
        },
        {
          prop: "cliente",
          label: "Cliente",
          minWidth: 100
        },
        {
          prop: "version",
          label: "Version",
          minWidth: 100
        },
        {
          prop: "descripcion",
          label: "Descripcion",
          minWidth: 150
        },
        {
          prop: "urlGoogle",
          label: "Url Google",
          width: 150
        },
        {
          prop: "urlApple",
          label: "Url Apple",
          width: 150
        },
        {
          prop: "archivoZipLink",
          label: "Archivo Zip",
          width: 150
        },
        {
          prop: "fechaMejora",
          label: "Fecha",
          width: 150,
          formatter: DatetimeFormatter
        }
      ],
      actions: [
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit"
        },
        {
          label: "Eliminar",
          icon: "el-icon-delete",
          command: "delete"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      list_customersSelect: "customers/list_to_select",
      loading_customers: "customers/isLoading"
    }),
    params() {
      return {
        companyId: this.currentCompany
      };
    }
  },
  created() {
    this.fetchCustomers();
    this.getVersionControls();
  },

  methods: {
    ...mapActions({
      fetchCustomers: "customers/getCustomers"
    }),
    resetForm1(formName) {
      this.$refs[formName].resetFields();
    },
    resetForm() {
      this.VersionControl.id = 0;
      this.VersionControl.nombre = "";
      this.VersionControl.version = "";
      this.VersionControl.clientCode = "";
      this.VersionControl.descripcion = "";
      this.VersionControl.urlGoogle = "";
      this.VersionControl.urlApple = "";
      this.VersionControl.archivoZipLink = "";
      this.filelist = [];
      this.isEdit = false;
    },
    CloseTransactionDetail() {
      this.openDetail = false;
      this.resetForm();
    },
    getVersionControls() {
      this.$http.get("/api/Technology/GetVersions").then((resp) => {
        this.items = resp.data;
      });
    },
    PosttVersionControl() {
      const params = {
        typerequest: this.typerequest,
        nombre: this.VersionControl.nombre,
        version: this.VersionControl.version,
        clientCode: this.VersionControl.clientCode,
        descripcion: this.VersionControl.descripcion,
        urlGoogle: this.VersionControl.urlGoogle,
        urlApple: this.VersionControl.urlApple,
        archivoZipLink: this.VersionControl.archivoZipLink,
        fechaMejora: new Date().toJSON()
      };
      console.log(params.fechaMejora);
      this.$refs["VersionControl"].validate((valid) => {
        if (valid) {
          this.$http
            .post("/api/Technology/AddVersion", params)
            .then(() => {
              this.$message.success("Agregado correctamente");
              this.getVersionControls();
              this.resetForm();
              this.mostrardetalles = false;
              this.CloseTransactionDetail();
            })
            .catch(() => {
              this.$message.info("Error al agregar");
            });
        }
      });
    },
    async PutVersionControl() {
      const params = {
        typerequest: this.typerequest,
        nombre: this.VersionControl.nombre,
        version: this.VersionControl.version,
        clientCode: this.VersionControl.clientCode,
        descripcion: this.VersionControl.descripcion,
        urlGoogle: this.VersionControl.urlGoogle,
        urlApple: this.VersionControl.urlApple,
        archivoZipLink: this.VersionControl.archivoZipLink
      };
      this.$refs["VersionControl"].validate((valid) => {
        if (valid) {
          this.$http
            .put(`/api/Technology/UpdateVersion/${params.id}`, params)
            .then(() => {
              this.$message.success("Actualizado correctamente");
              this.getVersionControls();
              this.resetForm();
              this.mostrardetalles = false;
              this.CloseTransactionDetail();
            })
            .catch(() => {
              this.$message.info("Error al actualizar");
            });
        }
      });
    },
    async DeleteVersionControl() {
      await this.$http
        .delete(`/api/Technology/DeleteVersion/${this.VersionControl.id}`)
        .then(() => {
          this.$message.success("Eliminado correctamente");
          this.getVersionControls();
          this.resetForm();
          this.mostrardetalles = false;
          this.CloseTransactionDetail();
        })
        .catch(() => {
          this.$message.info("Error al eliminar");
        });
    },
    manageVersion() {
      if (this.isEdit == true) {
        this.PutVersionControl();
      } else {
        this.PosttVersionControl();
      }
    },
    handleUploadOnSuccess(response) {
      const items_count = response.length;
      if (items_count > 0) {
        for (var index = 0; index < items_count; index++) {
          this.fileList.push({
            name: response[index].Name,
            url: response[index].Url
          });
        }
        this.VersionControl.archivoZipLink = this.fileList[0].url;
      }
    },
    callNew() {
      this.startedtime = true;
      this.BotonManage = "Guardar";
      this.sizedrawer = "30%";
      this.tituloDrawer = "Crear control de version";
      this.openDetail = true;
      this.mostrarTag = false;
      this.mostrarbotonquestion = false;
      this.isView = false;
      this.viewselect = false;
      this.mostrardetalles = false;
      this.posionlabel = "top";
      this.isEdit = false;
      this.imputpreguntas = "Tipo";
      this.drawer = true;
      this.mostrardescipccion = true;
      this.versioncontrolboton = true;
      this.frecuencia = true;
    },
    handlePushAction(command) {
      // this.No_Form = command.row.No_Form;
      // this.No_FormReal = command.row.No_FormReal;
      // this.ruleForm.startedtime = command.row.StartDate;
      // this.ruleForm.status = command.row.IsEnable;
      switch (command.command) {
        case "view":
          this.isView = true;
          this.openDetail = true;
          break;

        case "edit":
          this.startedtime = true;
          this.BotonManage = "Editar";
          this.sizedrawer = "30%";
          this.tituloDrawer = "Editar control de version";
          this.openDetail = true;
          this.mostrarTag = false;
          this.mostrarbotonquestion = false;
          this.isView = false;
          this.viewselect = false;
          this.mostrardetalles = false;
          this.posionlabel = "top";
          this.isEdit = true;
          this.imputpreguntas = "Tipo";
          this.drawer = true;
          this.mostrardescipccion = true;
          this.versioncontrolboton = true;
          this.VersionControl.id = command.row.id;
          this.VersionControl.nombre = command.row.nombre;
          this.VersionControl.version = command.row.version;
          this.VersionControl.clientCode = command.row.clientCode;
          this.VersionControl.cliente = command.row.cliente;
          this.VersionControl.descripcion = command.row.descripcion;
          this.VersionControl.archivoZipLink = command.row.archivoZipLink;
          this.VersionControl.urlGoogle = command.row.urlGoogle;
          this.VersionControl.urlApple = command.row.urlApple;
          break;
        case "delete":
          this.VersionControl.id = command.row.id;
          //console.log(command.row.id + this.VersionControl.id);
          this.$confirm("Segura/o que desea eliminar este registro ?")
            .then(() => {
              this.DeleteVersionControl();
            })
            .catch(() => {
              this.$message.info("Eliminacion cancelada");
            });
          break;

        default:
          break;
      }
    }
  }
};
</script>

<style>
.center-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 5vh;
}

.centered-tag {
  font-size: 1em;
  /* Ajusta el tamaño del texto según tus necesidades */
  /* Estilos adicionales del tag si es necesario */
}

.custom-form .el-form-item__label {
  display: none;
  /* Oculta la etiqueta predeterminada */
}

.custom-form .custom-label {
  display: block;
  font-weight: bold;
  /* Otras propiedades de estilo según tus preferencias */
  margin-bottom: 8px;
  /* Ajusta el margen inferior según tus necesidades */
}

.el-form-item__label {
  font-weight: bold;
  /* Otras propiedades de estilo según tus preferencias */
}
</style>
